import React from "react"
import { IconButton, Tooltip } from "@mui/material"

export const GenericIconButton = ({ icon, tooltip, color, disabled = false, ...others }) => {
  return (
    <Tooltip title={disabled ? "" : tooltip}>
      <IconButton disabled={disabled} {...others} size="small" sx={{ color: color, pointerEvents: "auto" }}>
        {icon}
      </IconButton>
    </Tooltip>
  )
}